// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"3940503f","990":"736be74c"}[chunkId] + ".chunk.js";
};